import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

import { getOrg } from '../utils/orgConfig';

// แสดงโลโก้ + ชื่อบริษัทจาก org/ (org/logo.png, org/config.json → company.name)
// - ไม่มีทั้งโลโก้และชื่อ: แสดง fallback แทน (ใส่ข้อความเดิมของหน้านั้นไว้ หน้าตาจึงเหมือนเดิม)
// - logoPlate: ใส่แผ่นพื้นขาวหลังโลโก้ ใช้บนพื้นเข้ม/พื้นไล่สีที่โลโก้สีเข้มจะมองไม่เห็น
// - showName=false: ซ่อนชื่อ (ที่แคบ เช่น แถบ sidebar) แล้วใช้ tooltip แสดงชื่อแทน
export default function OrgBrand({
  showName = true,
  logoHeight = 32,
  logoMaxWidth,
  logoPlate = false,
  direction = 'row',
  fallback = null,
  sx,
  logoSx,
  nameSx,
}) {
  const { company, logoUrl } = getOrg();
  const name = company.name;

  if (!name && !logoUrl) {
    return <>{fallback}</>;
  }

  const content = (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        flexDirection: direction,
        alignItems: 'center',
        gap: direction === 'row' ? 1 : 0.5,
        maxWidth: '100%',
        ...sx,
      }}
    >
      {logoUrl && (
        <Box
          component="img"
          src={logoUrl}
          alt={name || ''}
          sx={{
            height: logoHeight,
            maxWidth: logoMaxWidth || '100%',
            objectFit: 'contain',
            flexShrink: 0,
            ...(logoPlate && { bgcolor: '#fff', borderRadius: 1.5, p: 0.5, boxSizing: 'content-box' }),
            ...logoSx,
          }}
        />
      )}
      {showName && name && (
        <Typography
          component="span"
          sx={{ font: 'inherit', lineHeight: 1.2, ...nameSx }}
        >
          {name}
        </Typography>
      )}
    </Box>
  );

  return !showName && name ? <Tooltip title={name} placement="right">{content}</Tooltip> : content;
}
